"use client";
import moment from "moment";
import { cloneElement, isValidElement } from "react";
import NoData from "../NoData/NoData";
import PaginationComponent from "../PaginationComponent";
import classes from "./TableStructure.module.css";
import { cn, formatNumber } from "@/helper/HelperFunction";
import { recordsLimit } from "@/constant/constants";
import Skeleton from "@/components/Skeleton";

const TableStructure = ({
  isLoading,
  scrollRef,
  headerTitle = "Header",
  tableType = "default",
  headerHandlers = {},
  tableContent = [
    {
      name: <div>Lorem</div>,
      contact: "+123456789",
      courseName: "lorem",
      courseType: "lorem",
      status: "lorem",
      time: moment("16/01/2024").format("DD MM YYYY"),
    },
  ],
  tableHeaders = [
    { label: "NAME", value: "name", width: "50%" },
    { label: "CONTACT", value: "contact" },
    { label: "COURSE NAME", value: "courseName" },
    { label: "COURSE TYPE", value: "courseType" },
    { label: "STATUS", value: "status" },
    { label: "TIME", value: "time" },
  ],
  totalRecord = 0,
  recordLimit = recordsLimit,
  noDataMessage = "No Users Found",
  customStyle: tableCustomStyle,
  tableMinWidth,
  page = 1,
  setPage,
  tableFooter,
  isPagination = true,
  noBorder = false,
  sort,
  setSort,
}) => {
  const rows = Array(recordsLimit).fill(0);
  const cols = Array(tableHeaders?.length).fill(0);
  return (
    <div className={cn(classes.main, noBorder && classes.noBorder)}>
      <div className={headerTitle && classes.table_heading}>
        {headerTitle && (
          <span>
            {headerTitle && isValidElement(headerTitle)
              ? cloneElement(headerTitle, {
                  style: { marginInlineEnd: "auto" },
                })
              : headerTitle}
          </span>
        )}
        {Object?.keys(headerHandlers)?.length > 0 && (
          <div
            className={cn(
              classes.headerFilterDiv,
              !headerTitle && classes.headerFilterDiv__noTitle
            )}
          >
            {Object?.keys(headerHandlers)?.map((e, index) => {
              return headerHandlers[e];
            })}
          </div>
        )}
      </div>
      <div className={classes.scrollWrapper}>
        <div
          ref={scrollRef}
          style={tableCustomStyle}
          className={classes.tableWrapper}
        >
          <table
            className={classes.table}
            style={{ minWidth: `${tableMinWidth}px` }}
          >
            <thead
              className={cn(
                classes.tableHeader,
                headerTitle && classes.tableHeader__withTitle
              )}
            >
              <tr
                className={classes.tableRow}
                style={{
                  "--border-radius": "10px 10px 0px 0px",
                  // "--background": "var(--secondary-background)",
                }}
              >
                {Array.isArray(tableHeaders) &&
                  tableHeaders?.map((e, index) => {
                    if (!e) {
                      return;
                    }
                    return (
                      <th
                        className={classes.tableHead}
                        style={{
                          width: e?.width,
                          ...e?.headerStyle,
                        }}
                        key={index}
                      >
                        <div className={classes.sortContainer}>
                          <span className="no-wrap"> {e?.label}</span>
                          {e?.sortable !== false && setSort && (
                            <div className={classes.sortContainerIcons}>
                              <span
                                onClick={() => {
                                  !isLoading &&
                                    setSort({
                                      key: e?.value,
                                      order: "ASC",
                                    });
                                }}
                                style={{
                                  cursor: "pointer",
                                  height: "8px",
                                  width: "16px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color:
                                    sort?.key === e?.value &&
                                    sort?.order === "ASC"
                                      ? "var(--primary-color)"
                                      : "#5f606480",
                                }}
                              >
                                <svg
                                  stroke="currentColor"
                                  fill="currentColor"
                                  stroke-width="0"
                                  viewBox="0 0 20 20"
                                  aria-hidden="true"
                                  height="14px"
                                  width="14px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                                    clip-rule="evenodd"
                                  ></path>
                                </svg>
                              </span>
                              <span
                                onClick={() => {
                                  !isLoading &&
                                    setSort({
                                      key: e?.value,
                                      order: "DESC",
                                    });
                                }}
                                style={{
                                  cursor: "pointer",
                                  height: "8px",
                                  width: "16px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color:
                                    sort?.key === e?.value &&
                                    sort?.order === "DESC"
                                      ? "var(--primary-color)"
                                      : "#5f606480",
                                }}
                              >
                                <svg
                                  stroke="currentColor"
                                  fill="currentColor"
                                  stroke-width="0"
                                  viewBox="0 0 20 20"
                                  aria-hidden="true"
                                  height="14px"
                                  width="14px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                    clip-rule="evenodd"
                                  ></path>
                                </svg>
                              </span>
                            </div>
                          )}
                        </div>
                      </th>
                    );
                  })}
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                rows?.map((item, index) => (
                  <tr className={classes.tableRow} key={index}>
                    {cols?.map((item, i) => (
                      <td
                        style={{
                          width: `${100 / tableHeaders?.length}%`,
                          paddingBlock: "8px",
                          paddingInline: "10px",
                        }}
                        key={i}
                      >
                        <Skeleton
                          height={"40px"}
                          style={{
                            marginBottom: "10px",
                          }}
                        />
                      </td>
                    ))}
                  </tr>
                ))
              ) : tableContent.length > 0 ? (
                tableContent?.map((item, index) => {
                  return (
                    <tr
                      data-style={tableType}
                      key={index}
                      className={classes.tableRow}
                      style={{
                        "--border-bottom": "1px solid var(--border-color)",
                      }}
                    >
                      {tableHeaders?.map((e, index) => {
                        if (!e) {
                          return;
                        }
                        const customProps =
                          e?.formatting?.[e.value] &&
                          !isValidElement(item?.[e?.value])
                            ? e?.formatting[e.value](item)
                            : {};
                        const customClasses = customProps.className
                          ? structuredClone(customProps.className)
                          : undefined;
                        const customStyles = customProps.style
                          ? structuredClone(customProps.style)
                          : {};

                        delete customProps["style"];
                        delete customProps["className"];
                        return (
                          <td
                            className={[classes.tableData, customClasses].join(
                              " "
                            )}
                            style={{
                              width: e?.width,
                              ...e?.dataStyle,
                              ...customStyles,
                              ...(tableType === "secondary"
                                ? {
                                    borderBottom:
                                      "1px solid var(--gray-border)",
                                  }
                                : {}),
                            }}
                            key={index}
                            {...customProps}
                          >
                            {e?.type == "amount"
                              ? formatNumber(item?.[e?.value])
                              : item?.[e?.value]}{" "}
                            {e?.symbol === "%" && e?.symbol}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={tableHeaders?.length + 1}>
                    <NoData text={noDataMessage} className={classes.noData} />
                  </td>
                </tr>
              )}
            </tbody>
            {tableFooter && (
              <tfoot className={classes.tableFooter}>
                <tr className={classes.tableRow}>
                  {Array.isArray(tableFooter) &&
                    tableFooter?.map((e, index) => {
                      return (
                        <th
                          className={classes.tableHead}
                          style={{
                            ...e?.headerStyle,
                            ...(tableType === "secondary"
                              ? {
                                  borderBottom:
                                    "1px solid var( --primary-text-color)",
                                }
                              : {}),
                          }}
                          key={index}
                        >
                          {e}
                        </th>
                      );
                    })}
                </tr>
              </tfoot>
            )}
          </table>
        </div>
        {tableContent?.length > 0 && page && isPagination && (
          <div className={classes.Pagination}>
            <PaginationComponent
              totalPages={Math.ceil(totalRecord / recordLimit)}
              setCurrentPage={setPage}
              currentPage={Number(page)}
              totalRecord={totalRecord}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TableStructure;
